export const PhoneNumberSize = {
  MaxPhoneNumberSize: 12,
  MinPhoneNumberSize: 0,
}
export const HideErrorMessage = 3200